import React from 'react';
import styled from 'styled-components';
import { linkStyles } from '../_styles/linkStyles';
export const Link = ({ children, href, className, target = '_self', onClick, size = 'default', colour = 'default', download = false, }) => {
    const downloadProps = download ? { download: '' } : {};
    return (React.createElement(StyledLink, Object.assign({ href: href, target: target, size: size, colour: colour, className: className, onClick: onClick }, downloadProps), children));
};
const StyledLink = styled.a `
  ${linkStyles}
`;
